<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :detail-response-path="detailResponsePath"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getCompany } from '@/services/companies/getCompany'
import { getHistoricalByCIFComp } from '@/services/historical/getHistoricalByCIFComp'
import { getHistoricalByCIFCompExcel } from '@/services/historical/getHistoricalByCIFCompExcel'

export default {
  name: 'list-trash-company-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 28,
      vuexnamespace: 'trashHistoricalCompanies',
      headerUrl: 'trash/companies/details',
      detailResponsePath: 'CIFEmpresa',
      breadcrumbs: [
        { url: 'trash/companies', name: i18n.t('trash.header') },
        { url: 'trash/companies', name: i18n.t('trash.companies') },
        { paths: ['RazonSocial'] },
      ],
      ExcelName: `${_.kebabCase(i18n.tc('companies.entity_name', 1) + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  methods: {
    getParamsAux: function (data) {
      return { idCIF: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return {
        idCIFEmpresa: this.$route.params.id,
        borrado: true,
      }
    },
    getDetalleAux: async function (params) {
      return await getCompany(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByCIFCompExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByCIFComp(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
